import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CBadge, CButton, CCard, CCardBody, CCardFooter, CCardHeader } from "@coreui/react-pro";
import type { TrackerStrategyDto } from "../../../api/hooks/usePortfolioTracker";
import { routePaths } from "../../../routes/route-paths";
import { TrackerStrategyIdent } from "./TrackerStrategyIdent";

interface PickStrategiesProps {
  strategies: TrackerStrategyDto[];
  picked: ReadonlySet<string>;
  onToggle: (tradingStrategyId: string) => void;
  onNext: () => void;
}

/** Step 1: every strategy the customer gets signals for, the ones they follow already ticked. */
export function PickStrategies({ strategies, picked, onToggle, onNext }: PickStrategiesProps) {
  const { t } = useTranslation("portfolioTracker");

  return (
    <CCard className="tracker-step">
      <CCardHeader>
        <h2 className="h5 mb-0">{t("pick.title")}</h2>
        <p className="small text-body-secondary mb-0">{t("pick.description")}</p>
      </CCardHeader>
      <CCardBody>
        <div className="tracker-picks">
          {strategies.map((strategy) => {
            const on = picked.has(strategy.tradingStrategyId);
            return (
              <button
                key={strategy.tradingStrategyId}
                type="button"
                className="tracker-pick"
                aria-pressed={on}
                onClick={() => onToggle(strategy.tradingStrategyId)}
              >
                <span className="tracker-pick-box" aria-hidden="true" />
                <TrackerStrategyIdent strategy={strategy} />
                {strategy.following ? (
                  <CBadge color="primary" shape="rounded-pill">
                    {t("pick.following")}
                  </CBadge>
                ) : (
                  <span />
                )}
              </button>
            );
          })}
        </div>
      </CCardBody>
      <CCardFooter className="tracker-step-foot">
        <Link to={routePaths.signals} className="btn btn-outline-secondary">
          {t("pick.cancel")}
        </Link>
        <span className="d-flex align-items-center gap-3">
          <span className="small text-body-secondary">{t("pick.count", { count: picked.size })}</span>
          <CButton color="primary" disabled={picked.size === 0} onClick={onNext}>
            {t("pick.next")}
          </CButton>
        </span>
      </CCardFooter>
    </CCard>
  );
}
